/**
 * Curated list of passport-issuing countries for KYC.
 * Common ASEAN + frequent-traveler markets surfaced first, alphabetical thereafter.
 */
export interface CountryOption {
  value: string
  label: string
}
const PRIORITY: CountryOption[] = [
  { value: 'MY', label: 'Malaysia' },
  { value: 'SG', label: 'Singapore' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'TH', label: 'Thailand' },
  { value: 'PH', label: 'Philippines' },
  { value: 'VN', label: 'Vietnam' },
  { value: 'BN', label: 'Brunei' },
]
const REST: CountryOption[] = [
  { value: 'AU', label: 'Australia' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'CA', label: 'Canada' },
  { value: 'CN', label: 'China' },
  { value: 'EG', label: 'Egypt' },
  { value: 'FR', label: 'France' },
  { value: 'DE', label: 'Germany' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'IN', label: 'India' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IT', label: 'Italy' },
  { value: 'JP', label: 'Japan' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'KR', label: 'South Korea' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'LA', label: 'Laos' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'MV', label: 'Maldives' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'QA', label: 'Qatar' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'ES', label: 'Spain' },
  { value: 'TR', label: 'Turkey' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'US', label: 'United States' },
  { value: 'OTHER', label: 'Other' },
]
export const PASSPORT_COUNTRIES: CountryOption[] = [...PRIORITY, ...REST]
